import React from "react";

export default function ArowIndicator({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="19"
      viewBox="0 0 10 19"
      fill="none"
      className={className}
    >
      <path
        d="M0.353516 17.7517L9.05261 9.05261L0.353517 0.353515"
        stroke="#817B50"
      />
    </svg>
  );
}
